// WiFi 정보 섹션 컴포넌트
import { Check, Copy, Wifi } from 'lucide-react';
import type { WaiterRequestTranslations } from './types';

interface WifiInfoSectionProps {
  wifiSSID: string;
  wifiPassword: string;
  passwordCopied: boolean;
  translations: WaiterRequestTranslations;
  onCopyPassword: () => void;
  onConnectWifi: () => void;
}

export function WifiInfoSection({
  wifiSSID,
  wifiPassword,
  passwordCopied,
  translations,
  onCopyPassword,
  onConnectWifi,
}: WifiInfoSectionProps) {
  return (
    <div className="space-y-2.5 p-3 rounded-xl bg-muted/50 border border-border/50">
      <div className="flex items-center gap-2">
        <Wifi className="h-4 w-4 text-secondary" />
        <h3 className="text-[13px] font-medium text-foreground">
          {translations.wifiSection}
        </h3>
      </div>

      <div className="space-y-1.5">
        <div className="flex items-center justify-between">
          <span className="text-[11px] text-muted-foreground">
            {translations.wifiName}
          </span>
          <code className="text-[12px] font-mono text-foreground">
            {wifiSSID}
          </code>
        </div>

        <div className="flex items-center justify-between gap-2">
          <span className="text-[11px] text-muted-foreground">
            {translations.wifiPassword}
          </span>
          <div className="flex items-center gap-1.5">
            <code className="text-[12px] font-mono text-foreground">
              {wifiPassword}
            </code>
            <button
              onClick={onCopyPassword}
              className="p-1 rounded hover:bg-border transition-colors"
            >
              {passwordCopied ? (
                <Check className="h-3.5 w-3.5 text-primary" />
              ) : (
                <Copy className="h-3.5 w-3.5 text-muted-foreground" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* WiFi 바로 등록 버튼 */}
      <button
        onClick={onConnectWifi}
        className="w-full mt-2 px-3 py-2 rounded-lg bg-gradient-to-r from-secondary to-secondary/70 hover:from-secondary/90 hover:to-secondary/60 text-white text-[12px] font-medium transition-all duration-200 flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
      >
        <Wifi className="h-3.5 w-3.5" />
        <span>{translations.connectWifi}</span>
      </button>
    </div>
  );
}
